var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementActivityNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 17L20.6484 14.3554L21.1309 13.8729C21.8624 13.1414 21.8624 11.9559 21.1309 11.2245C20.3994 10.493 19.2139 10.493 18.4824 11.2245L17.9999 11.7069L17.5175 11.225C16.786 10.4935 15.6005 10.4935 14.869 11.225C14.138 11.9559 14.138 13.1419 14.869 13.8729L15.3515 14.3549L17.9999 17.0034",
    stroke: "#BBBBBB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0623 30.7387C10.0623 30.7387 13.9162 24.9873 13.0563 22.5213C12.2143 20.1083 7.51882 20.2388 8.04031 11.6989C8.45831 4.86049 14.1707 4 17.7577 4C25.4536 4 27.9971 8.63045 27.9971 12.5434C27.9971 14.1739 27.1491 15.7389 27.1491 17.0434C27.1491 18.3473 27.9316 18.6738 27.9971 19.5213C28.0621 20.3693 27.0186 21.1953 27.0186 21.1953",
    stroke: "#BBBBBB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5733 30.7387C21.5733 30.7387 19.7798 28.8802 19.7798 27.5432C19.7798 26.2063 19.9753 25.5213 19.9753 25.5213C19.9753 25.5213 22.8448 26.5322 24.1817 25.8803C25.5187 25.2278 25.4212 24.1193 25.4212 24.1193",
    stroke: "#BBBBBB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementActivityNegative);
export default __webpack_public_path__ + "static/media/achievement-activity-negative.baee0b2a6d00466804d47b3fa0f539c5.svg";
export { ForwardRef as ReactComponent };